module.exports = __webpack_public_path__ + "static/6-c0fa801dbf7e8a4ce6d17b376f2d1ff8.jpg";